const addToCartLoginModal = window && window.AddToCartLoginModal || {}
const client = {
    displayAddToCartLoginModal() {
        return addToCartLoginModal.displayAddToCartLoginModal && addToCartLoginModal.displayAddToCartLoginModal();
    }
}

export default client;